import { type Env, EnvSchema } from '@/types/env';

function parseEnv(): Env {
  const result = EnvSchema.safeParse(import.meta.env);

  if (result.success) {
    return result.data;
  }

  const missing = result.error.issues
    .map((i) => `  ${i.path.join('.')}: ${i.message}`)
    .join('\n');

  const message = `Environment validation failed:\n${missing}`;
  console.error(message);

  // Render a visible error so Playwright/developers see it immediately.
  // instead of a silent white screen
  if (typeof document !== 'undefined') {
    const el = document.getElementById('app');
    if (el) {
      el.innerHTML = `
        <pre style="color:#dc2626;padding:2rem;font-family:monospace;font-size:14px;white-space:pre-wrap">
⚠ ${message}

Hint: All client-side env vars must be prefixed with VITE_ and defined in .env
See webapp/.env.example for the full list.
        </pre>`;
    }
  }

  throw new Error(message);
}

export const env: Env = parseEnv();
